module.exports = __webpack_public_path__ + "static/media/3XL.308ace03.jpg";